import { useEffect } from 'react'
import { setOnUnauthorized } from '@core/http-client'
import { useSessionLogout } from '@features/session'

/**
 * Registers a full logout (session back to guest + evict query caches) as the http-client's 401 handler,
 * so an expired bearer can't leave the UI half-authed. Mount once at app level.
 */
export const useUnauthorizedLogout = () => {
    const logoutSession = useSessionLogout()

    useEffect(() => {
        setOnUnauthorized(logoutSession)

        return () => setOnUnauthorized(null)
    }, [logoutSession])
}
